import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconFont = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "m11.307 4-6 16h2.137l1.875-5h6.363l1.875 5h2.137l-6-16h-2.387zm-1.239 9L12.5 6.515 14.932 13h-4.864z" }) }));
const Memo = memo(SvgIconFont);
export default Memo;
//# sourceMappingURL=IconFont.js.map